import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import query from '../../query';
import './ComplaintReply.scss';
import { API_URL } from '../../config/api';

const ComplaintReply = ({ complaintId, onSuccess }) => {
  const [message, setMessage] = useState('');
  const [files, setFiles] = useState([]);

  const [createComplaintMessage, { loading }] = useMutation(
    query.createComplaintMessage
  );

  const handleFiles = event => {
    setFiles(Array.from(event.target.files));
  };

  const uploadAttachments = async (complaintMessageId, files) => {
    const formData = new FormData();

    files.forEach(file => {
      formData.append('files[]', file);
    });

    const token = localStorage.getItem('user_auth_data');

    const response = await fetch(
      `${API_URL}/complaint_messages/${complaintMessageId}/attachments`,
      {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Accept': 'application/json'
        },
        body: formData
      }
    );

    if (!response.ok) {
      throw new Error('Unable to upload attachments.');
    }

    const json = await response.json();
    return json;
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      const { data } = await createComplaintMessage({
        variables: {
          complaintId,
          description: message
        }
      });

      const result = data.createComplaintMessage;

      if (!result.success) {
        alert('Unable to send reply.');
        return;
      }

      if (files.length > 0) {
        await uploadAttachments(result.complaintMessageId, files);
      }

      setMessage('');
      setFiles([]);

      if (onSuccess) {
        onSuccess();
      }

    } catch (error) {
      console.error(error);
      alert(error.message);
    }
  };

  return (
    <div className="complaint-reply">

      <h4 className="text-theme">Reply</h4>

      <form onSubmit={handleSubmit}>

        <div className="form-group">

          <label>Your message</label>

          <textarea
            className="form-control"
            rows="6"
            placeholder="Type your reply..."
            value={message}
            onChange={e => setMessage(e.target.value)}
          />

        </div>

        <div className="form-group">

          <label>Attachments</label>

          <input
            type="file"
            multiple
            onChange={handleFiles}
          />

          {files.length > 0 && (
            <div className="selected-files">
              {files.map(file => (
                <div key={file.name}>
                  <i className="fa fa-paperclip mr-2" />
                  {file.name}
                </div>
              ))}
            </div>
          )}

        </div>

        <div className="text-right">

          <button
            type="submit"
            className="save-button text-white"
            disabled={!message.trim() || loading}
          >
            {loading ? 'Sending...' : 'Send Reply'}
          </button>

        </div>

      </form>

    </div>
  );
};

export default ComplaintReply;
